export const getTimeDuration = (
  startTime: Date | number | string,
  unit: "ms" | "s" = "s",
) => {
  const startDate = new Date(startTime);
  const diff = Math.floor(Date.now() - startDate.getTime());
  return unit === "ms" ? diff : Math.floor(diff / 1000);
};

export const secondsToMinutes = (seconds: number | string): number => {
  const s = typeof seconds === "string" ? parseFloat(seconds) : seconds;
  if (Number.isNaN(s)) return 0;
  return Number((s / 60).toFixed(1));
};

export const getDayLeft = (validUntil?: string) => {
  if (!validUntil) return 0;
  const target = new Date(validUntil);
  const now = new Date();
  const diffMs = target.getTime() - now.getTime();
  const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return daysLeft;
};
